import React, { useEffect } from 'react';
import { fetchUser, logout } from 'store/user';
import { useAppDispatch, useTypedSelector } from 'store/index';
import { useHistory } from 'react-router-dom';
import useLogin from 'common/useLogin';
import { report, setReportUser } from 'store/report';
import { Button } from '@tencent/spaui';

const login = () => {
  location.href = `https://sso.e.qq.com/login/hub?sso_redirect_uri=${encodeURIComponent(location.href)}&service_tag=80`;
};

const regist = () => {
  console.log('===open regist');
  // window.open('https://e.qq.com/tech-agency-reg/');
  window.open('/regist');
};

const UserContainer: React.FC<{ toggle?: boolean }> = ({ toggle }) => {
  const { user, accountList } = useTypedSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const history = useHistory();

  useEffect(() => {
    report({ event: 'open', url: location.href });

    history.listen((location) => {
      report({ event: 'view', url: location.pathname });
    });
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, []);

  const loginPending = useLogin(toggle);
  useEffect(() => {
    if (loginPending || user) {
      return;
    }

    if (toggle) {
      dispatch(fetchUser(true)).then((res: any) => {
        if (!res.payload[0]) {
          login();
        } else {
          setReportUser();
        }
      });
    } else {
      dispatch(fetchUser(false)).then(setReportUser);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps*/
  }, [loginPending, user]);

  if (accountList && accountList !== null) {
    history.replace('/login/portal');
    return null;
  }

  if (!user) {
    return (
      <>
        <Button
          style={{ marginRight: '24px' }}
          className="a-button"
          displayType="primary"
          data-track="login"
          onClick={login}
        >
          免费发布需求
        </Button>
        <Button style={{ marginRight: '24px' }} className="a-button" displayType="primary" onClick={regist}>
          服务商入驻
        </Button>
        <Button className="a-button" displayType="primary" data-track="login" onClick={login}>
          立即登录
        </Button>
      </>
    );
  }

  const name = user.login_type === 1 ? user.qq_nick_name : user.wx_nick_name;
  const avatar = user.login_type === 1 ? user.qq_figure_url_40_40 : user.wx_head_url;
  const info = user.login_type === 1 ? `QQ：${user.qq_number}` : `微信：${user.wx_id || user.wx_nick_name}`;

  return (
    <div className="top-container user-container">
      <div className="content">
        <img src={avatar} alt="avatar" />
        <span className="text-bold name" title={name}>
          {name}
        </span>
        <span className="caret" />
      </div>
      <div className="dropdown">
        <div className="info">
          <img src={avatar} alt="avatar" />
          <div className="info-list">
            <div className="text-bold name">{name}</div>
            <div>用户ID：{user.user_id}</div>
            <div>{info}</div>
            <div>SAAS服务商ID：{user.agency_id}</div>
          </div>
        </div>
        <div className="bottom">
          {toggle ? (
            <span className="logout" role="button" onClick={() => dispatch(logout()).then(login)}>
              切换账户
            </span>
          ) : (
            <>
              <span className="logout" role="button" data-track="logout" onClick={() => dispatch(logout())}>
                退出
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserContainer;
